<template>
    <ReportContainer>
      <template #filter>
        <b-form-group
          label="As of Date">
          <b-form-datepicker  v-model="filters.ar.asOfDate"
            :date-format-options="{
              'year': 'numeric', 'month': 'long', 'day': 'numeric'
            }"/>
        </b-form-group>
        <b-button variant="outline-primary" @click="onPreviewAr()">Preview</b-button>
      </template>
      <template #content>
        <ReportViewer :reportSource="file.src" :isLoading="file.isLoading"/>
      </template>
    </ReportContainer>
</template>

<script>
import { ReportApi } from '../../mixins/api'
import ReportContainer from '../components/ReportContainer'
import ReportViewer from '../components/ReportViewer'
export default {
  components: {
    ReportContainer,
    ReportViewer
  },
  mixins: [ ReportApi ],
  data() {
    return {
      isLoading: false,
      filters:{ 
        ar: {
          asOfDate: new Date
        }
      },
      file: {
        src: '',
        isLoading: false
      }
    }
  },
  methods: {
    onPreviewAr() {
      const { asOfDate } = this.filters.ar
      this.file.src = ''
      this.file.isLoading = true
      const params = { asOfDate }
      this.previewAccountsReceivableReport(params).then(response  => {
        const file = new Blob([response.data], { type: "application/pdf" } )
          const reader = new FileReader();
          reader.onload = e => this.file.src = e.target.result
          reader.readAsDataURL(file);
          this.file.isLoading = false
      })
    },
  }
  
}
</script>

<style lang="scss" scoped>
  .ar-detailed__container {
    height: 100%;
    width: 100%;
  }
</style>